import type { CategoryWithItemsType } from "@/types/category";
import type { CategoryType } from "@/types/category";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { useTranslation } from "react-i18next";

const fetchCategories = async (
  includeItems: boolean = false,
  lang: string,
  companyId?: string
) => {
  const url = `https://kaman.rest/api/${
    includeItems ? "categories-with-items" : "categories"
  }?lang=${lang}${companyId ? `&company_id=${companyId}` : ""}`;

  const response = await axios.get(url);
  return response.data.data.categories;
};

export function useCategories(
  includeItems: true,
  companyId?: string
): ReturnType<typeof useQuery<CategoryWithItemsType[]>>;

export function useCategories(
  includeItems?: false,
  companyId?: string
): ReturnType<typeof useQuery<CategoryType[]>>;

export function useCategories(
  includeItems: boolean = false,
  companyId?: string
) {
  const { i18n } = useTranslation();

  return useQuery({
    queryKey: ["categories", i18n.language, includeItems, companyId],
    queryFn: () => fetchCategories(includeItems, i18n.language, companyId),
  });
}
